import { useNavigate } from 'react-router-dom'

import { useAuth } from '@/auth/AuthProvider'

function formatTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' }).format(date)
}

/**
 * "Ansicht als <email> — nur lesen · endet um HH:MM · Beenden", shown for the
 * whole duration of a staff impersonation session — see the staff console
 * contract's Web section. Renders nothing for an ordinary sign-in
 * (`impersonatedBy` is only ever set by `AuthProvider.beginImpersonation`).
 */
export function ImpersonationBanner() {
  const { user, impersonatedBy, impersonationExpiresAt, endImpersonation } = useAuth()
  const navigate = useNavigate()

  if (!impersonatedBy) return null

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-3 rounded-sm bg-warning-subtle px-4 py-2 text-small text-warning-text"
    >
      <span>
        {/* The account being looked at, not the staff member doing the
            looking — `impersonatedBy` names who is impersonating, `user` is
            whose session this is. Confirmed by an actual run, where this
            used to print the staff member's own email here. */}
        Ansicht als <strong>{user?.email}</strong> — nur lesen
        {impersonationExpiresAt && ` · endet um ${formatTime(impersonationExpiresAt)}`}
      </span>
      <button
        type="button"
        className="font-semibold underline underline-offset-2"
        onClick={() => {
          void endImpersonation().then(() => navigate('/login', { replace: true }))
        }}
      >
        Beenden
      </button>
    </div>
  )
}
